import React, {Component} from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {connect} from 'react-redux';
import {Card, Button, Grid, Input, Dropdown} from 'semantic-ui-react';
import {hasAccessPermission} from '../../common/permissions/validations';
import {resources, scopes} from '../../common/permissions/dictionary';
import {downloadFile} from '../../common/util/file';
import {paths} from '../../common/dictionaries/urls';
import {Actions} from '../../common/actions';
import {dateFormatPicker, dateFormatShortMonth} from '../../common/constants/datesFormat';
import {typeOption, dealerOrderTypes} from '../../common/constants/lists';
import {getServiceRateParams, parseIccGroup, parseIcc} from '../utils';
import ServiceReportPartInfo from './info';
import './serviceReportPart.scss';

class ServiceReportPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'type': 'R',
      'requestType': 'S',
      'icc': [],
      'iccGroup': ['A', 'B', 'C', 'D', 'E'],
      'endDateFilter': moment().format(dateFormatShortMonth),
      'startDateFilter': moment()
        .subtract(6, 'days')
        .format(dateFormatShortMonth),
      'filteredOptions': [],
      'settingInfo': false,
    };
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.ServiceReportPart,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }

    this.props.deleteServiceReport();
    this.props.fetchIcc();
    this.search();
  }

  componentDidUpdate(prevProps, prevState) {
    const {urlFile, iccOptions} = this.props;
    const {filteredOptions, iccGroup} = this.state;

    if (urlFile) {
      downloadFile(urlFile);
      this.props.deleteUrlServiceRate();
    }

    if (!filteredOptions.length && iccOptions.length) {
      this.setState({'filteredOptions': iccOptions});
    }
    if (prevState.iccGroup.length !== iccGroup.length) {
      let filteredOptions = iccOptions;
      if (iccGroup.length !== 0) {
        filteredOptions = filteredOptions.filter((icc) =>
          iccGroup.some((group) => group === icc.value[0])
        );
      }
      this.setState({filteredOptions, 'icc': []});
    }
  }

  search = () => {
    const {isUserFromTDE, dealerId} = this.props;
    const dealer = isUserFromTDE ? '' : dealerId;
    const filters = {...this.state, dealer};
    const params = getServiceRateParams(filters);
    this.props.fetchServiceRate(params);

    if (!isUserFromTDE) {
      this.props.fetchDealer(dealerId);
      this.setSettingInfo(true);
    }
  };

  setSettingInfo = (settingInfo) => {
    this.setState({settingInfo});
  };

  download = () => {
    const {isUserFromTDE, dealerId} = this.props;
    const dealer = isUserFromTDE ? '' : dealerId;
    const filters = {...this.state, dealer};
    const params = getServiceRateParams(filters);
    this.props.downloadServiceRateFile(params);
  };

  changeEndDate = (date) => {
    const dateFormatted = date ? moment(date).format(dateFormatShortMonth) : null;

    if (dateFormatted === this.state.endDateFilter) {
      return;
    }
    this.setState({'endDateFilter': dateFormatted});
  };

  changeStartDate = (date) => {
    const dateFormatted = date ? moment(date).format(dateFormatShortMonth) : null;

    const {startDateFilter, endDateFilter} = this.state;
    if (dateFormatted === startDateFilter) {
      return;
    }
    this.setState({'startDateFilter': dateFormatted});
    if (!endDateFilter) {
      this.setState({'endDateFilter': dateFormatted});
    }
  };

  render() {
    const {iccGroupOptions, iccLoading, serviceRateLoading, loadingUrl} = this.props;
    const {
      icc,
      iccGroup,
      startDateFilter,
      endDateFilter,
      type,
      requestType,
      filteredOptions,
      settingInfo,
    } = this.state;

    return (
      <div className='service-rate-container'>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Consulta Tasa de Servicio</h2>
              <div className='title-bar-actions'>
                <Button
                  primary
                  className='toyota-primary'
                  disabled={loadingUrl || iccLoading || serviceRateLoading}
                  onClick={this.search}
                >
                  Consultar
                </Button>
                <Button
                  primary
                  className='toyota-primary'
                  loading={loadingUrl}
                  disabled={serviceRateLoading || iccLoading}
                  onClick={this.download}
                >
                  Descargar
                </Button>
              </div>
            </div>
            <div className='filters-section'>
              <Grid textAlign='left'>
                <Grid.Row columns='equal'>
                  <Grid.Column width={2}>
                    <h4>Fecha Inicio</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        startDateFilter ?
                          moment(
                            startDateFilter,
                            dateFormatShortMonth
                          ).toDate() :
                          null
                      }
                      onChange={this.changeStartDate}
                      locale='es'
                      placeholderText='Fecha Inicio'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Fecha Fin</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <DatePicker
                      customInput={<Input icon='calendar' size='small' />}
                      dateFormat={dateFormatPicker}
                      selected={
                        endDateFilter ?
                          moment(endDateFilter, dateFormatShortMonth).toDate() :
                          null
                      }
                      onChange={this.changeEndDate}
                      locale='es'
                      placeholderText='Fecha Fin'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Tipo Pedido</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown
                      selection
                      search
                      value={requestType}
                      onChange={(e, {value}) =>
                        this.setState({'requestType': value})
                      }
                      name='list-invoices-container'
                      options={[...dealerOrderTypes, {'value': 'T', 'text': 'TODOS'}].map((x, i) => {
                        return {
                          ...x, 'key': i,
                        };
                      })}
                      placeholder='Seleccionar...'
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns='equal'>
                  <Grid.Column width={2}>
                    <h4>Tipo</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <Dropdown
                      selection
                      search
                      value={type}
                      onChange={(e, {value}) =>
                        this.setState({'type': value})
                      }
                      name='list-invoices-container'
                      options={typeOption}
                      placeholder='Seleccionar...'
                    />
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Icc</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <div className='table.icc-form'>
                      <Dropdown
                        selection
                        search
                        fluid
                        value={iccGroup}
                        multiple
                        onChange={(e, {value}) =>
                          this.setState({'iccGroup': value})
                        }
                        options={iccGroupOptions}
                        placeholder='Seleccionar icc'
                      />
                    </div>
                  </Grid.Column>
                  <Grid.Column width={2}>
                    <h4>Icc Detalle</h4>
                  </Grid.Column>
                  <Grid.Column width={3}>
                    <div className='table.icc-form'>
                      <Dropdown
                        selection
                        search
                        fluid
                        value={icc}
                        multiple
                        onChange={(e, {value}) =>
                          this.setState({'icc': value})
                        }
                        options={filteredOptions}
                        placeholder='Seleccionar icc'
                      />
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>
        </Card>
        <ServiceReportPartInfo
          setSettingInfo={this.setSettingInfo}
          settingInfo={settingInfo}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const iccOptions = parseIcc(state.iccServiceRate.iccOptions);
  const iccGroupOptions = parseIccGroup(state.iccServiceRate.iccOptions);
  return {
    'permissions': state.session.permissions,
    'isUserFromTDE': state.session.isUserFromTDE,
    'dealerId': state.session.dealerId,
    'urlFile': state.serviceRate.urlFile,
    'loadingUrl': state.serviceRate.loadingUrl,
    'serviceRateLoading': state.serviceRate.loading,
    'iccLoading': state.iccServiceRate.loading,
    iccOptions,
    iccGroupOptions,
  };
};

const {
  fetchIcc,
  navigateTo,
  fetchDealer,
  deleteServiceReport,
  downloadServiceRateFile,
  deleteUrlServiceRate,
  fetchServiceRate,
} = Actions;

export default connect(mapStateToProps, {
  fetchIcc,
  navigateTo,
  fetchDealer,
  deleteServiceReport,
  fetchServiceRate,
  downloadServiceRateFile,
  deleteUrlServiceRate,
})(ServiceReportPart);
